import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { ErrorBoundary } from 'react-error-boundary';
import { GlobalStyles } from './globalStyles.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const ErrorFallback = _ref => {
  let {
    error
  } = _ref;
  return /*#__PURE__*/jsxs("div", {
    role: "alert",
    children: [/*#__PURE__*/jsxs("p", {
      children: ["Something went wrong within your ", /*#__PURE__*/jsx("code", {
        children: "ThemeProvider"
      }), ":"]
    }), /*#__PURE__*/jsx("pre", {
      children: error.message
    })]
  });
};
const ThemeProvider = _ref2 => {
  let {
    children,
    theme
  } = _ref2;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    FallbackComponent: ErrorFallback,
    children: /*#__PURE__*/jsxs(ThemeProvider$1, {
      theme: theme,
      children: [/*#__PURE__*/jsx(GlobalStyles, {}), children]
    })
  });
};

export { ThemeProvider };
